module.exports = __webpack_public_path__ + "hero-select.2f42af18.png";